<template>
    <div class="relative">
        <slot name="tabs" :tabs="tabs">
            <div v-for="(tab, idx) in tabs" @click="setTabActive(idx)">
                <slot name="tab" :tab="tab">{{ tab.text }}</slot>
            </div>
        </slot>
        <slot></slot>
    </div>
</template>

<script>

function formatSegment(path) {
    return path.toLowerCase().replace(/ /g, '-');
}

export default {
    name: 'tabs',
    props: {
        active: Number,
        wrap: String,
        // a route param name defined in Vue router routes. this.$route.params[paramName]
        // to determine which tab has been selected. The tab's text is compared
        routeParam: String,
        routeName: String
    },
    data() {
        return {
            // Cannot directly use $children in the template, because
            // it's only available when mounted is called
            tabs: [],
            calcWidth: 0,
        }
    },
    watch: {
        active(val) {
            this.setTabActive(val)
        },
        $route(to, from) {
            if (to.name) {
                this.checkRoute(to.name)
            }
        }
    },
    methods: {
        setTabActive(index) {
            this.$emit('update:active', index)

            for (let tab of this.tabs) {
                tab.instance.setInactive()
            }
            var tab = this.tabs[index].instance
            tab.setActive()

            if (tab.route) {
                this.$router.push({name: tab.route})
            }
            
            if (this.routeParam) {
                const segment = formatSegment(tab.text);
                if (segment === this.$route.params[this.routeParam]) {
                    return;
                }
                
                // hardcoded portal name
                const params = {
                    ...this.$route.params,
                    [this.routeParam]: segment
                };
                
                // This is to clear the secondary tab when primary tab is clicked.
                // This is a very specific solution for this case where the current
                // route structure is /primaryTab/secondaryTab, as set in portal.js.
                // A more generic solution might be considered in the future.
                if(this.routeParam === "primaryTab"){
                    params["secondaryTab"] = null
                }
                
                this.$router.push({
                    name: this.routeName, 
                    params
                });
            }
        },
        checkRoute(name) {
            var index = this.tabs.findIndex(t => t.route == name)
            if (index != -1) {
                this.setTabActive(index)
            }
        },
        findTabIndex() {
            const index = this.routeParam 
                ? this.tabs.findIndex(t => formatSegment(t.text) === this.$route.params[this.routeParam])
                : this.active;
            return index === -1 ? this.active : index;
        }
    },
    mounted() {
        this.tabs = this.$children.map(c => ({
            text: c.text,
            route: c.route,
            data: c.data,
            instance: c
        }))
        
        // Set tracker and active tab after tabs has been rendered
        this.$nextTick(() => {
            this.setTabActive(this.findTabIndex())
        })
    }
}
</script>

